import React, { Component } from "react";
import { observer } from "mobx-react";
import LayerStore from "../../../../stores/LayerStore";
import img1 from "../../../../static-file/images/step01_img1.png";
import img2 from "../../../../static-file/images/step01_img2.png";
import img3 from "../../../../static-file/images/step01_img3.png";
import img4 from "../../../../static-file/images/step01_img4.png";
import img5 from "../../../../static-file/images/step01_img5.png";
import img6 from "../../../../static-file/images/step01_img6.png";
import pre_btn from "../../../../static-file/images/pre_btn.png";
import pre_btn_black from "../../../../static-file/images/pre_btn_black.png";
import pre_btn_gray from "../../../../static-file/images/pre_btn_gray.png";
import next_btn from "../../../../static-file/images/next_btn.png";
import next_btn_black from "../../../../static-file/images/next_btn_black.png";
import BlankIcon from "../../../../static-file/images/logo/blank.png";

@observer
class OnboardingStep_01 extends Component {
  constructor(props) {
    super(props);
    this.state = { cnt: 1 };
    this.rootStore = {
      layerStore: LayerStore,
    };
  }

  cntUp = () => {
    const { rootStore } = this;
    if (this.state.cnt < 6) {
      this.setState({ cnt: this.state.cnt + 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("02");
      this.setState({ cnt: 1 });
    }
  };

  cntDown = () => {
    const { rootStore } = this;
    if (this.state.cnt > 1) {
      this.setState({ cnt: this.state.cnt - 1 });
    }
  };

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;

    let img = BlankIcon;
    let prev_icon = BlankIcon;
    let next_icon = BlankIcon;

    if (this.state.cnt === 1) {
      img = img1;
      prev_icon = pre_btn_gray;
      next_icon = next_btn;
    } else if (this.state.cnt === 2) {
      img = img2;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 3) {
      img = img3;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 4) {
      img = img4;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 5) {
      img = img5;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 6) {
      img = img6;
      prev_icon = pre_btn;
      next_icon = next_btn_black;
    } else {
      img = BlankIcon;
    }

    return (
      <div
        className={"layer_comm layer_common_type " + (layerStore.getChangeOnboardingStep === "01" ? " layer_open" : "")}
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="article_common_type">
            <div className="section">
              <div className="detail">
                <div className="top">
                  <span
                    className="top_txt"
                    onClick={event => {
                      layerStore.setChangeOnboardingStep("");
                      layerStore.setLayerOnboardingView(true);
                      this.setState({ cnt: 1 });
                    }}
                  >
                    &lt; &nbsp; 처음으로
                  </span>
                  <span className="top_sub">&nbsp;&nbsp;&nbsp;Step 01. 주문접수 프린터 설정</span>
                </div>
                <div className={this.state.cnt === 1 ? "tit" : "hide"}>
                  <p className="num">
                    <span>1</span>
                  </p>
                  <p className="txt">
                    <strong>[사이드메뉴 &gt; 설정 &gt; 프린터 설정]</strong>을 순서대로 클릭하세요.
                  </p>
                </div>
                <div className={this.state.cnt === 2 ? "tit" : "hide"}>
                  <p className="num">
                    <span>2</span>
                  </p>
                  <p className="txt">
                    주문접수 프린터 <strong>[사용]으로 변경</strong> 후 <strong>연결포트를 선택</strong>합니다.
                    <br />
                    <strong>[테스트 출력]</strong>을 통해 연결이 잘 되었는지 확인합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 3 ? "tit" : "hide"}>
                  <p className="num">
                    <span>3</span>
                  </p>
                  <p className="txt">
                    <strong>테스트 주문서가 출력</strong>되었다면 <strong>[출력확인] 버튼을 클릭</strong>합니다.
                    <br />
                    <em>(출력이 안된 경우 [재설정] 버튼 클릭 후, 포트를 재설정합니다)</em>
                  </p>
                </div>
                <div className={this.state.cnt === 4 ? "tit" : "hide"}>
                  <p className="num">
                    <span>4</span>
                  </p>
                  <p className="txt">
                    테스트 출력 후, 주문서 인식 테스트를 진행합니다.
                    <br />
                    <strong>주문서 인식성공 팝업</strong>이 뜨면 <strong>바로 사용</strong>해주시면 됩니다.
                  </p>
                </div>
                <div className={this.state.cnt === 5 ? "tit" : "hide"}>
                  <p className="num">
                    <span>5</span>
                  </p>
                  <p className="txt">
                    <strong>주문서 인식실패 팝업</strong> 생성 시, <strong>PC재부팅</strong> 후 다시 시도해주세요.
                  </p>
                </div>
                <div className={this.state.cnt === 6 ? "tit" : "hide"}>
                  <p className="num">
                    <span>6</span>
                  </p>
                  <p className="txt">
                    더 자세한 사항은 <strong>모바일 매뉴얼</strong>을 확인해주세요.
                  </p>
                </div>
                <div className="content">
                  <p className="pre">
                    <span className="btn" onClick={this.cntDown}>
                      <img src={prev_icon} alt={"prevButton"} />
                    </span>
                    {/* <span className={(this.state.cnt===1?'txt':'hide')}>처음으로</span> */}
                  </p>
                  <p className="img">
                    <img src={img} alt={"content"} />
                  </p>
                  <p className="next">
                    <span className="btn" onClick={this.cntUp}>
                      <img src={next_icon} alt={"nextButton"} />
                    </span>
                    <span className={this.state.cnt === 6 ? "txt" : "hide"}>다음 안내</span>
                  </p>
                </div>
                <div className="page">
                  <ul className="pagination modal">
                    <li className={this.state.cnt === 1 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 2 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 3 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 4 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 5 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 6 ? "location" : "num"}></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="btn_close">
              <button
                onClick={event => {
                  layerStore.setChangeOnboardingStep("");
                  this.setState({ cnt: 1 });
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingStep_01;
